/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PuescStatus,
    PuescStatusFromJSON,
    PuescStatusFromJSONTyped,
    PuescStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface PuescStatusResponse
 */
export interface PuescStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof PuescStatusResponse
     */
    monitoredObjectId: string;
    /**
     * 
     * @type {string}
     * @memberof PuescStatusResponse
     */
    transportId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PuescStatusResponse
     */
    puescSentGeoStale: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PuescStatusResponse
     */
    puescSentGeoError: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PuescStatusResponse
     */
    unavailableGps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PuescStatusResponse
     */
    monitoringDeviceStale: boolean;
    /**
     * 
     * @type {PuescStatus}
     * @memberof PuescStatusResponse
     */
    status: PuescStatus;
}

export function PuescStatusResponseFromJSON(json: any): PuescStatusResponse {
    return PuescStatusResponseFromJSONTyped(json, false);
}

export function PuescStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PuescStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectId': json['monitored_object_id'],
        'transportId': !exists(json, 'transport_id') ? undefined : json['transport_id'],
        'puescSentGeoStale': json['puesc_sent_geo_stale'],
        'puescSentGeoError': json['puesc_sent_geo_error'],
        'unavailableGps': json['unavailable_gps'],
        'monitoringDeviceStale': json['monitoring_device_stale'],
        'status': PuescStatusFromJSON(json['status']),
    };
}

export function PuescStatusResponseToJSON(value?: PuescStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object_id': value.monitoredObjectId,
        'transport_id': value.transportId,
        'puesc_sent_geo_stale': value.puescSentGeoStale,
        'puesc_sent_geo_error': value.puescSentGeoError,
        'unavailable_gps': value.unavailableGps,
        'monitoring_device_stale': value.monitoringDeviceStale,
        'status': PuescStatusToJSON(value.status),
    };
}


